import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { DataService } from './services/data.service';
import { DataLogin } from './services/dataLogin.service';
import { CookieService } from 'ngx-cookie-service';
import { LogInModel } from './models/Login';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  isLoading = true; 


  constructor(private router: Router,
    private route: ActivatedRoute,
    public dataService: DataService,
    public dataLogin: DataLogin,
    private cookieService: CookieService) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const fragment = window.location.hash.split('?')[1]; 

    if (fragment) {
      const urlParams = new URLSearchParams(fragment); 
      const encryptedData = urlParams.get('data');

      if (encryptedData) {
        try {
          this.dataLogin.logInObj = new LogInModel();
          this.dataLogin.logInObj.encryptedData = encryptedData

          this.dataLogin.ValidateLoginByContactForAccountId().then((res: string) => {
            this.dataLogin.Loader = false;
            
            if (!this.dataService.IsError(res)) {
              var jsonRes = JSON.parse(res);
              this.dataService.years = jsonRes.Years;
              delete jsonRes.Years;
              this.dataService.institutions = jsonRes.Institutions;
              delete jsonRes.Institutions;
              this.dataService.userModel = jsonRes;
              this.dataService.selectedAccount = this.dataService.institutions.find(i => i.InstitutionNumber == this.dataService.userModel.InstitutionNumber);
              this.setDataInCookies();
              this.dataService.isLoggedIn = true;


           
              this.router.navigateByUrl('institotion-calendar');
              this.dataLogin.step = "1";//תשים את מסך הלוגין הראשוני כדי שבהתנתקות האוטומטית הוא יגע לשם
              this.dataService.SetActivity();
              this.dataLogin.Loader = false;     
              this.isLoading = false;  
              return false; 
            }
          }).catch(error => {
            this.isLoading = false;
            return true;  
          });

        } catch (error) {
          console.error("Decryption error:", error.message);
          this.isLoading = false;
          return true;  
        }
      } else {
        console.log("No encrypted data in URL.");
        this.isLoading = false;

        return true;
      }
    } else {
      console.log("No fragment in URL.");
      this.isLoading = false;

      return true;
    }
  }
  setDataInCookies() {
    this.cookieService.set("Token", this.dataService.userModel.Token);
    this.cookieService.set("AcountFullName", this.dataService.userModel.AcountFullName);
    this.cookieService.set("InstitutionName", this.dataService.userModel.InstitutionName);
    this.cookieService.set("InstitutionNumber", this.dataService.userModel.InstitutionNumber);
    this.cookieService.set("BuisnesUnitPhone", this.dataService.userModel.BuisnesUnitPhone);
    this.cookieService.set("Year", JSON.stringify(this.dataService.userModel.Year));
    this.cookieService.set("Years", JSON.stringify(this.dataService.years));
    this.cookieService.set("Institutions", JSON.stringify(this.dataService.institutions));
    this.cookieService.set("ContactMail", this.dataService.userModel.ContactMail);
    this.cookieService.set("ContactPhone", this.dataService.userModel.ContactPhone);
    this.cookieService.set("useLogin","false");
    this.cookieService.set("SystemUserFullName", this.dataService.userModel.SystemUserFullName);

    this.cookieService.set("IsEditStudentAllowed", String(this.dataService.userModel.IsEditStudentAllowed));
    this.cookieService.set("IsEditScheduleAllowed", String(this.dataService.userModel.IsEditScheduleAllowed));
    sessionStorage.setItem("isSignedIn", "true");
  }

  addHours(h) {
    return h * 60 * 60 * 1000;
  }
}
